// src/components/Logos.js

import React, { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import './Logos.css'; // Uses .logo-svg to size the SVG

const GeorgianLogo = () => (
  <svg
    className="logo-svg"
    id="Layer_1_georgian"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 737 175.4"
    aria-label="Georgian Logo"
  >
    <defs>
      <style>{`.st0 { fill: #2484c6; fill-rule: evenodd; }`}</style>
    </defs>
    <g>
      <path
        className="st0"
        d="M122.3,93.7c5.1-2,11-2.4,17.3.1,7.5,2.2,13.8,1.8,17.8-.3l-3.3-5.6c-2.2,1.4-8.1,1.8-13.5,0-6.5-2.6-10.2-2.1-14.1-1.3l-4.2,7.1h0Z"
      />
      <path
        className="st0"
        d="M114.7,106.6l5.7-9.6c4.9-2.5,10.6-3.3,18-1.3,6.7,2.4,14,3.1,20-.2l6.8,11.1h-50.5Z"
      />
      <path
        className="st0"
        d="M127.8,84.1l12.2-20.3,13,21.9c-3,2.1-6.9,1.7-12.6-.3-6.1-1.8-7.9-2.1-12.6-1.2h0Z"
      />
      <path
        className="st0"
        d="M114.3,110.3h1.7s2.6,4.4,2.6,4.4v-4.4c0,0,1.3,0,1.3,0v6.1s-1.5,0-1.5,0l-2.7-4.6v4.6c0,0-1.3,0-1.3,0v-6.1h0ZM123.7,111.4c-.5,0-.8.1-1.1.4-.2.2-.4.6-.4,1.1h3.7s0,1.1,0,1.1h-3.7c0,.2,0,.4,0,.6,0,.2.2.4.3.5.1.2.3.2.5.3.2,0,.4,0,.6,0h2.2s0,1.1,0,1.1h-2.2c-.4,0-.7,0-1,0-.3,0-.6-.2-.9-.4-.4-.3-.6-.6-.7-1-.2-.4-.2-.8-.2-1.2v-.3c0,0,0-.2,0-.3,0-1,.3-1.7.8-2.1.5-.5,1.2-.7,2.1-.7h2.2s0,1.1,0,1.1h-2.2ZM126.3,110.3h1.4s1.5,4.7,1.5,4.7l1.2-4.7h1.6l1.4,4.7,1.3-4.7h1.4s-1.9,6.1-1.9,6.1h-1.6s-1.3-4.6-1.3-4.6l-1.2,4.6h-1.6s-2.1-6.1-2.1-6.1h0ZM142.6,116.4c-.4,0-.8,0-1.1,0-.3,0-.7-.2-1-.6-.2-.2-.4-.5-.5-.9,0-.3-.1-.7-.1-1v-3.7s1.3,0,1.3,0v3.4c0,.6,0,1,.2,1.3.1.3.5.4,1.2.4h1.5s0,1,0,1h-1.7ZM146.4,116.4h-1.4s0-6.1,0-6.1h1.4s0,6.1,0,6.1h0ZM150,113.9v-1.1s3.1,0,3.1,0v3.6s-2.8,0-2.8,0c-.4,0-.7,0-1.1,0-.3,0-.6-.2-.9-.4-.4-.3-.6-.6-.7-1-.1-.4-.2-.8-.2-1.2v-.3c0,0,0-.2,0-.3,0-1,.3-1.7.8-2.1.5-.4,1.2-.7,2.1-.7h2.8s0,1,0,1h-2.8c-.6,0-1,.2-1.2.7-.2.4-.3.9-.3,1.4h0c0,.5,0,1,.3,1.4.2.4.6.6,1.2.6h1.5s0-1.5,0-1.5h-1.8ZM155.5,110.3v2.5s2.4,0,2.4,0v-2.5s1.3,0,1.3,0v6.1s-1.3,0-1.3,0v-2.6s-2.4,0-2.4,0v2.6s-1.3,0-1.3,0v-6.1s1.3,0,1.3,0h0ZM161.9,111.3h-2s0-1.1,0-1.1h5.4s0,1.1,0,1.1h-2s0,5.1,0,5.1h-1.4s0-5.1,0-5.1h0Z"
      />
    </g>
    <g>
      <path
        className="st0"
        d="M220.9,62.1h4.2c-.2,9.4.3,19.6-.1,29.3-.1,3.1-.1,6.5.9,8.9.8.9,3.4.9,5.3.8,5.3,0,11,0,15.9,0v5.8c-5.9,0-12.5-.2-18.3-.2-2.8,0-5.5-.3-6.7-2.1-1.8-1.4-2.2-5.4-2.2-8.8,0-10,.1-21,.1-32.7,0-.1,0-.2.1-.2Z"
      />
      <path
        className="st0"
        d="M317.9,63.9c0,1.9,0,4,0,5.8-5.3,0-10.5-.3-16,0-1.6,0-3.7,0-4.7.5-1.3.8-1.4,3.3-1.4,5.5,0,2.5,0,4.8,0,6.8,0,2.5-.1,4.8.1,6.8.8,5.9,5.2,8.8,10.3,10.3,3.5,1,7,1.3,11.7,1.5v5.6c-6,0-10.7-.4-15.2-2.2-6-2.5-10.4-7.1-11.2-15-.2-2.4,0-5.2,0-8.2s0-5.6.1-8.4c.2-3.1.4-6.6,2.5-7.9.8-.5,1.9-.7,3-.8,6.5-.6,13.9,0,21-.2Z"
      />
      <path
        className="st0"
        d="M359.4,106.4c-1.4,0-3,0-4.4,0,0-10.2,0-20.9,0-31.4s.1-3.3-.4-4.1c-.8-1.1-3.5-1-5.4-1-4.7,0-8.6-.1-12.7-.1s-5-.1-5.9,1.1c-.7.9-.6,2.3-.7,3.9-.5,10.3,0,21.7-.2,32.3h-4.4c.2-10.3-.3-21.4.2-31.8.2-3.5-.1-7.2,1.5-9.1,2.3-2.7,7.9-2,12.7-2s7.7.1,11.6.1,5.8.3,7,2.2c1.3,2.1,1.1,5.7,1.1,9.2,0,10.4,0,20.5,0,30.9Z"
      />
      <path
        className="st0"
        d="M184.5,64c13.6.1,24.7,3.9,26.3,16.5.3,2.5.1,5.4.1,8.4s0,5.6-.1,8.5c-.1,3.5-.4,7.1-2.5,8.4-1.3.8-3.4.8-5.4.9-5.8.3-12.6-.1-18.5,0-.2-1.9,0-3.9,0-5.8,4.6.1,10.4,0,15.6,0s4,.1,5.1-.5c1.3-.8,1.3-3.3,1.4-5.4,0-2.5,0-4.7,0-6.7s.1-4.8-.1-6.7c-.7-5.9-4.9-8.9-10-10.4-3.5-1.1-7.5-1.5-12-1.5v-5.6c0,0,0-.2,0-.2Z"
      />
      <path
        className="st0"
        d="M260.5,64.2c13.2.1,24.5,3.7,26.2,16.2.3,2.4.2,5.4.2,8.4s0,5.6-.1,8.5c-.2,3.7-.2,7.4-2.5,8.8-1.2.8-3.3.9-5.1,1-6.2.4-12.6-.3-18.8,0-.1-1.8,0-4.2,0-5.8,5.3,0,10.7,0,16.1,0s3.6,0,4.7-.6c1.3-.8,1.3-3.4,1.3-5.5,0-2.5,0-4.7,0-6.7,0-5,0-8.8-1.9-11.6-3.8-5.4-11.4-6.7-20.2-6.8v-5.6c0,0,0-.2,0-.2Z"
      />
      <path
        className="st0"
        d="M395.4,64.5c9.7,0,19.4,0,29.2.1v5.8c-8.3,0-16.5,0-24.8,0-.2,7.6-.1,15.8-.1,23.9,0,2.6-.1,6,1.3,6.9.9.5,3.6.6,4.6.6,5.2.1,11.1-.1,16.2,0v5.8c-5.8,0-12.6,0-18.5-.2-2.2,0-4.5,0-5.8-1.1-1.8-1.4-2.2-5.4-2.2-8.8,0-10.7,0-21.9,0-32.7,0-.1,0-.2.1-.2Z"
      />
      <path
        className="st0"
        d="M474.3,64.5c10.9-.2,22.2.2,33.2.2s3.7,0,5.5.1c2.8.1,5.1.3,6.1,2.3,1.2,2.2,1,5.8,1,9.2,0,10-.1,20.4-.2,30.3h-4.4c0-10,.1-20.7.1-31.2s.1-3.4-.5-4.1c-1.1-1.1-4.3-.9-6.6-.9s-5.3,0-7.6,0c.6,5.4.3,12,.3,18,0,6.2,0,12.5,0,18.5h-4.3c0-8.7,0-17.9,0-26.9,0-3.5.3-7.4-1.7-8.8-2.2-1.4-6.4-.9-10-.9s-7.5,0-11,0v-5.6c0,0,0-.2.1-.2Z"
      />
      <path
        className="st0"
        d="M434.2,64.6c13.6,0,24.6,3.8,26.2,16.5.3,2.5.2,5.3.2,8.4,0,2.9,0,5.5,0,8.5-.2,3.7-.4,7.5-3,8.7-1.4.7-3.5.6-5.4.7-5.5.2-12.4-.2-18.1,0,0-1.9,0-4,0-5.8,4.7-.1,10.6.1,15.9,0,1.9,0,4.4,0,5.3-1,.9-1.1.9-3.8.9-5.8,0-2.3,0-4.6,0-6.7.2-5,0-8.5-2.1-11.3-3.8-5.3-11.2-6.4-20-6.5v-5.6c0,0,0-.2,0-.2Z"
      />
      <path
        className="st0"
        d="M468.5,64.6h4.3v27.6c0,2.9-.3,6,.9,8.1,1.2.9,3,.8,4.8.8,5.5,0,11.3,0,16.7,0v5.8c-5.9,0-12.5,0-18.6-.2-2.5,0-5.3-.1-6.5-1.6-1.5-1.8-1.5-5.5-1.7-8.8-.2-3.5,0-7.2,0-10.5,0-7.1.1-14,0-21,0,0,0-.2,0-.2Z"
      />
      <path
        className="st0"
        d="M560.6,64.7c4.6,0,9.9,0,14.8,0,2,0,3.7.2,4.7,1.2,1.6,1.5,1.6,4.6,1.6,7.4,0,3,0,5.9,0,8.9,3.2.3,6.5,0,8.1,1.9,1.7,2.2,1.6,6.8,1.7,10.7.1,4.1-.2,8.4,0,12.2h-4.4c0-4.7.2-9.7,0-14.6,0-1.6-.3-3.4-1.4-4-1-.6-3-.4-4.8-.4-4.9,0-10.9-.1-15.8,0v-5.8h13.2c.1-2.1,0-4.4,0-6.7s.2-5.1-1.1-5.8c-.8-.5-2.4-.4-3.9-.4h-12.8v-4.5c0-.1,0-.2.1-.2Z"
      />
      <path
        className="st0"
        d="M596.3,65c13.6.1,24.7,3.9,26.2,16.5.3,2.5.2,5.4.2,8.4s0,5.5-.1,8.4c-.2,3.5-.4,7.4-2.7,8.7-1.4.7-3.4.8-5.3.8-5.9.2-12.2-.1-18.4,0v-5.8h11.1c3.5,0,7.5.5,10-.7,1-1.4,1-3.5,1.1-5.6,0-2.1,0-4.5,0-6.7s.2-4.7-.1-6.6c-.3-1.9-1-3.6-1.9-4.8-3.7-5.4-11.2-6.6-20.1-6.7,0-1.9,0-3.8,0-5.6,0,0,0-.2,0-.2Z"
      />
      <path
        className="st0"
        d="M526.6,65.2c6.3,0,12.2,0,18.6.2,2.8,0,5.2.3,6.4,2,1.4,2,1.4,5.8,1.5,9.1.2,3.6,0,6.9,0,10.5s0,7,0,10.5c0,4.5-.4,8.7-3.8,9.7-1.4.4-3.4.5-5.3.5-5.6,0-12.1,0-17.4,0,0-1.8,0-3.8,0-5.8,5.4,0,10.9,0,16.4,0s3.7,0,4.6-.7c1.2-1,1.1-4.4,1.2-6.7,0-5.3,0-10.3,0-15.6s.1-5.2-.9-6.9c-1.2-.9-3-.7-4.7-.8-5.4-.4-11.2.2-16.5-.1v-5.6c0,0,0-.2,0-.2Z"
      />
      <path
        className="st0"
        d="M227.2,81.8c5.7,0,12.6,0,18.5.2,2.7.1,5,.2,6.2,1.7,1.7,2.1,1.6,7,1.6,10.7s0,8.4,0,12.3c-1.4,0-3.1,0-4.3,0-.1-4.4.2-9.5,0-14.1,0-1.7-.1-3.7-1.3-4.4-.9-.6-2.9-.5-4.2-.6-5.1-.3-11.4.2-16.5,0v-5.6c0,0,0-.2,0-.2Z"
      />
      <path
        className="st0"
        d="M401.7,82.2c3.7,0,7.6,0,11.5,0,1.9,0,3.9-.1,5.8,0,3.5.3,6.7,0,8,2.5,1.3,2.5,1.1,6.8,1.1,10.6,0,4,0,8.1,0,11.6h-4.4c-.2-4.3.2-9.3,0-14,0-1.8-.2-3.9-1.5-4.5-.9-.5-3.2-.5-4.7-.5-5.3,0-10.7,0-15.9,0v-5.6c0,0,0-.2,0-.2Z"
      />
      <path
        className="st0"
        d="M559.3,82.4h4.3c.1,4.6-.3,9.6,0,14.1,0,1.4.1,3.1.8,3.9.8.9,2.8.8,4.7.8,5.5,0,11,.1,16.5,0v5.8c-5.7-.3-12.5.4-18.5,0-2.4-.2-4.6-.2-5.9-1.3-1.1-1-1.5-2.8-1.8-4.7-.7-5.2-.2-12.4-.2-18.3,0,0,0-.2,0-.2Z"
      />
    </g>
  </svg>
);

const EnglishLogo = () => (
  <svg
    className="logo-svg"
    id="Layer_1_english"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 419.9 108"
    aria-label="English Logo"
  >
    <defs>
      <style>{`.st0 { fill: #2484c6; fill-rule: evenodd; }`}</style>
    </defs>

    <path
      className="st0"
      d="M49.5,57.1c3.9-1.5,8.4-1.8,13.1.1,5.7,1.7,10.4,1.4,13.5-.2l-2.5-4.2c-1.7,1.1-6.1,1.4-10.2,0-4.9-2-7.7-1.6-10.7-1l-3.2,5.3Z"
    />
    <path
      className="st0"
      d="M43.7,66.8l4.3-7.3c3.7-1.9,8-2.5,13.6-1,5.1,1.8,10.6,2.3,15.1-.1l5.2,8.4h-38.2Z"
    />
    <path
      className="st0"
      d="M53.7,49.9l9.2-15.4,9.9,16.6c-2.3,1.6-5.2,1.3-9.6-.2-4.6-1.4-6-1.6-9.5-.9"
    />
    <path
      className="st0"
      d="M43.4,69.7h1.3s2,3.3,2,3.3v-3.3c0,0,1,0,1,0v4.6s-1.2,0-1.2,0l-2.1-3.5v3.5c0,0-1,0-1,0v-4.7ZM50.6,70.5c-.4,0-.6.1-.8.3-.2.2-.3.5-.3.8h2.8s0,.8,0,.8h-2.8c0,.2,0,.3,0,.5,0,.1.1.3.2.4.1.1.2.2.4.2.1,0,.3,0,.4,0h1.7s0,.8,0,.8h-1.7c-.3,0-.5,0-.8,0-.3,0-.5-.2-.7-.3-.3-.2-.5-.5-.6-.8-.1-.3-.2-.6-.2-.9v-.2c0,0,0-.1,0-.2,0-.7.2-1.3.6-1.6.4-.3.9-.5,1.6-.5h1.7s0,.8,0,.8h-1.6ZM52.5,69.7h1.1s1.1,3.6,1.1,3.6l.9-3.6h1.2l1.1,3.6,1-3.6h1s-1.5,4.6-1.5,4.6h-1.2s-1-3.5-1-3.5l-.9,3.5h-1.2s-1.6-4.6-1.6-4.6ZM64.9,74.3c-.3,0-.6,0-.8,0-.3,0-.5-.2-.7-.4-.2-.2-.3-.4-.4-.6,0-.2,0-.5,0-.7v-2.8s1,0,1,0v2.5c0,.4,0,.8.2,1,.1.2.4.3.9.3h1.2s0,.8,0,.8h-1.3ZM67.7,74.3h-1s0-4.6,0-4.6h1s0,4.6,0,4.6ZM70.4,72.4v-.8s2.4,0,2.4,0v2.8s-2.1,0-2.1,0c-.3,0-.5,0-.8,0-.2,0-.5-.2-.7-.3-.3-.2-.5-.5-.6-.8-.1-.3-.2-.6-.2-.9v-.2c0,0,0-.1,0-.2,0-.7.2-1.3.6-1.6.4-.3.9-.5,1.6-.5h2.2s0,.8,0,.8h-2.2c-.5,0-.8.2-.9.5-.1.3-.2.7-.2,1.1h0c0,.4,0,.7.2,1,.1.3.4.4.9.4h1.1s0-1.1,0-1.1h-1.3ZM74.6,69.6v1.9s1.8,0,1.8,0v-1.9s1,0,1,0v4.7s-1,0-1,0v-1.9s-1.8,0-1.8,0v1.9s-1,0-1,0v-4.6s1,0,1,0ZM79.5,70.4h-1.5s0-.8,0-.8h4.1s0,.8,0,.8h-1.5s0,3.8,0,3.8h-1s0-3.8,0-3.8Z"
    />
    <path
      className="st0"
      d="M96.4,33.2h9.2s14.2,24.2,14.2,24.2l-.4-24.3h7.4v33.8c0,0-8.4,0-8.4,0l-14.9-25.5.4,25.6h-7.4s0-33.8,0-33.8Z"
    />
    <path
      className="st0"
      d="M148.1,39c-2.7,0-4.7.7-6,2.1-1.3,1.4-2,3.3-2.2,5.8h20.1c0-.1,0,5.8,0,5.8h-20.2c0,1.2.2,2.3.4,3.5.3,1,.8,2.1,1.7,3,.8.9,1.6,1.4,2.6,1.6,1,.3,2,.3,3.1.3h12.4c0,0,0,5.8,0,5.8h-12.3c-2,0-3.8-.1-5.6-.5-1.9-.3-3.5-1.1-5.2-2.4-2-1.5-3.3-3.3-4-5.6-.8-2.2-1.2-4.5-1.3-6.8v-1.4c0-.5,0-1,0-1.4.3-5.4,1.8-9.3,4.4-11.7,2.6-2.5,6.5-3.8,11.8-3.8h12.1c0,0,0,5.8,0,5.8h-11.9Z"
    />
    <path
      className="st0"
      d="M162.5,33.1h7.8s8.1,25.9,8.1,25.9l6.7-26h8.6l7.8,25.9,7.4-26h7.4s-10.6,33.8-10.6,33.8h-8.9s-7.4-25.2-7.4-25.2l-6.4,25.2h-8.8s-11.6-33.7-11.6-33.7Z"
    />
    <path
      className="st0"
      d="M252,66.7c-2.2,0-4.3-.1-6.1-.5-1.9-.3-3.7-1.4-5.3-3-1.3-1.4-2.2-3-2.5-4.7-.4-1.8-.6-3.6-.6-5.4v-20.1s7.3,0,7.3,0v18.5c0,3.1.4,5.5,1.1,7.2.7,1.7,3,2.5,6.9,2.5h8.5s0,5.6,0,5.6h-9.2Z"
    />
    <path
      className="st0"
      d="M272.8,66.7h-7.6s0-33.8,0-33.8h7.6s0,33.8,0,33.8Z"
    />
    <path
      className="st0"
      d="M292.4,52.6v-6s17.2,0,17.2,0v20s-15.6,0-15.6,0c-2,0-3.9-.2-5.8-.5-1.8-.3-3.5-1.2-5.2-2.5-2-1.5-3.3-3.3-4.1-5.6-.7-2.2-1.2-4.5-1.2-6.8v-1.4c0-.5,0-1,0-1.4.3-5.3,1.8-9.2,4.4-11.7,2.6-2.5,6.5-3.8,11.8-3.8h15.6c0-.1,0,5.7,0,5.7h-15.6c-3.4.1-5.6,1.2-6.6,3.6-1.1,2.3-1.5,4.9-1.5,7.7h0c0,2.9.5,5.4,1.6,7.5,1,2.1,3.2,3.1,6.6,3.1h8.2c0,0,0-8,0-8h-9.7Z"
    />
    <path
      className="st0"
      d="M322.8,32.8v13.7s13.4,0,13.4,0v-13.7s7.3,0,7.3,0v33.8s-7.2,0-7.2,0v-14.1s-13.3,0-13.3,0v14.1s-7.3,0-7.3,0v-33.8s7.2,0,7.2,0Z"
    />
    <path
      className="st0"
      d="M358.2,38.7h-11.1s0-5.8,0-5.8h29.8s0,5.8,0,5.8h-11.2s0,27.9,0,27.9h-7.4s0-27.9,0-27.9Z"
    />
  </svg>
);

const Logos = () => {
  const { language } = useContext(LanguageContext);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', margin: '5px 0' }}>
      <a href="/" style={{ textDecoration: 'none' }}>
        {language === 'ka' ? <GeorgianLogo /> : <EnglishLogo />}
      </a>
    </div>
  );
};

export default Logos;
